import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-consumption-line-graph',
    templateUrl: './consumption-line-graph.component.html',
    styleUrls: ['./consumption-line-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsumptionLineGraphComponent {
  view: [number, number] = [600, 400];

// options
  legend = false;
  showLabels = true;
  animations = true;
  xAxis = true;
  yAxis = true;
  showYAxisLabel = true;
  showXAxisLabel = true;
  xAxisLabel = '';
  yAxisLabel = 'Consommation en kWh';
  timeline = false;

  colorScheme: Color = {
    name: 'consommations',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#40d01e', '#FF5722']
  };
  @Input() public multiLines: any[];
  @ViewChild('divWrapper') divWrapper: ElementRef;

  constructor() {
    this.view = [window.innerWidth / 1.95, 400];
  }

  onSelect(data): void {
  }

  onActivate(data): void {
  }

  onDeactivate(data): void {
  }

  onResize(event) {
    this.view = [this.divWrapper.nativeElement.offsetWidth , 400];
  }
}
